import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import {
  API_MONITORED_ACCOUNTS,
  API_USERS,
  API_WALLETS,
} from "../../utils/apis";
import {
  createColumn,
  createEditAction,
  formatCurrency,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_MONITORED_ACCOUNTS } from "../../utils/urls";
import useGet from "../common/useGet";

export const useMonitoredAccounts = () => {
  const tableColumns = () => [
    createColumn("account_name", true, "Account Name"),
    createColumn("people_to_notify_details", true, "People to Notify"),
    createColumn("send_hourly_balances", false, "Send Hourly Balances"),
    createColumn("monitor_balances", false, "Monitor Balances"),
    createColumn(
      "minimum_balance_threshold",
      true,
      "Minimum Balance Threshold",
    ),
    createColumn(
      "maximum_balance_threshold",
      true,
      "Maximum Balance Threshold",
    ),
    createColumn("is_active", false, "Is Active"),
    createColumn("created_at", true, "Created At"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        people_to_notify_details: item?.people_to_notify_details?.map(
          (person: any) => {
            return person.first_name + " " + person.last_name + ", ";
          },
        ),
        send_hourly_balances: (
          <BooleanTags status={item?.send_hourly_balances} />
        ),
        monitor_balances: <BooleanTags status={item?.monitor_balances} />,
        minimum_balance_threshold: formatCurrency(
          item?.minimum_balance_threshold,
        ),
        maximum_balance_threshold: formatCurrency(
          item?.maximum_balance_threshold,
        ),
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDateTime(item?.created_at),
        actions: (
          <FormActions
            actions={[createEditAction(URL_MONITORED_ACCOUNTS, item?.id)]}
          />
        ),
      };
    }),
  ];

  //   const viewData = (item: any) => {};

  const formRoute = getForm(URL_MONITORED_ACCOUNTS);

  return {
    tableColumns,
    tableData,
    formRoute,
    // viewData,
  };
};

export const useMonitoredAccountsForm = () => {
  const { data: wallets, loadData: loadWallets, loading, error } = useGet();
  const {
    data: users,
    loadData: loadUsers,
    loading: usersLoading,
    error: usersError,
  } = useGet();

  useEffect(() => {
    loadWallets({ api: API_WALLETS });
    loadUsers({ api: API_USERS });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Monitored Account",
      fields: [
        {
          field_name: "wallet",
          label: "Wallet",
          type: "select",
          props: { required: true },
          options_data: wallets?.map((wallet: any) => ({
            id: wallet?.name,
            name: wallet?.key,
          })),
        },
        {
          field_name: "people_to_notify",
          label: "People to Notify",
          type: "select",
          props: { required: true, multiple: true },
          options_data: users?.results?.map((user: any) => ({
            id: user?.id,
            name: user?.first_name + " " + user?.last_name,
          })),
        },
        {
          field_name: "send_hourly_balances",
          label: "Send Hourly Balances",
          type: "select",
          props: { required: true },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "minimum_balance_threshold",
          label: "Minimum Balance Threshold",
          type: "decimal",
          props: { required: true, min: 0 },
        },
        {
          field_name: "maximum_balance_threshold",
          label: "Maximum Balance Threshold",
          type: "decimal",
          props: { required: true, min: 0 },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_MONITORED_ACCOUNTS);

  return { sections, redirect, loading, error, usersLoading, usersError };
};

export function submitMonitoredAccounts(payload: any, id: string) {
  if (id) {
    return {
      id,
      api: API_MONITORED_ACCOUNTS,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_MONITORED_ACCOUNTS,
    params: {
      ...payload,
    },
  };
}
